import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { NavigationStacks, Screens, Stacks } from 'components/Navigation/types';
import { useScreenSize } from 'hooks/useScreenSize';
import * as React from 'react';
import { StyleSheet, View } from 'react-native';
import { AssessmentSetupLibraryScreen } from 'screens/AssessmentSetupLibraryScreen/AssessmentSetupLibraryScreen';
import { AssessmentSetupScreen } from 'screens/AssessmentSetupScreen/AssessmentSetupScreen';
import { BillingScreen } from 'screens/BillingScreen/BillingScreen';
import { FieldSettingsScreen } from 'screens/FieldSettings/FieldSettingsScreen';
import { OrganisationScreen } from 'screens/OrganisationScreen/OrganisationScreen';
import { ProfileScreen } from 'screens/ProfileScreen/ProfileScreen';
import { SyncIndicator } from 'screens/SyncScreen/SyncIndicator';

import { SettingsAssessmentCompliance } from 'screens/SettingsAssessmentCompliance/SettingsAssessmentCompliance';
import { ApiScreen } from 'screens/ApiScreen/ApiScreen';
import { EngageSettingsScreen } from 'screens/EngageSettingsScreen/EngageSettingsScreen';
import { BillingAdminScreen } from 'screens/BillingScreen/BillingAdminScreen';
import { SsoSettingsScreen } from 'screens/SsoSettingsScreen/SsoSettingsScreen';
import { SettingsExplorerScreen } from './SettingsExplorerScreen';
import { GeneralSettingsScreen } from './GeneralSettingsScreen';

const StackNavigator =
  createNativeStackNavigator<NavigationStacks[Stacks.SETTINGS]>();

export const SettingsScreen: React.FC = () => {
  const screenSize = useScreenSize();

  const stack = React.useMemo(
    () => (
      <StackNavigator.Navigator
        initialRouteName={
          screenSize === 'small'
            ? Screens.SETTINGS_EXPLORER
            : Screens.SETTINGS_PROFILE
        }
        screenOptions={{
          animation: screenSize === 'small' ? 'default' : 'none',
          headerShown: false,
        }}
      >
        {screenSize === 'small' && (
          <StackNavigator.Screen
            name={Screens.SETTINGS_EXPLORER}
            component={SettingsExplorerScreen}
          />
        )}
        <StackNavigator.Screen
          name={Screens.SETTINGS_PROFILE}
          component={ProfileScreen}
        />
        <StackNavigator.Screen
          name={Screens.SETTINGS_BILLING}
          component={BillingScreen}
        />
        <StackNavigator.Screen
          name={Screens.SettingsBillingAdmin}
          component={BillingAdminScreen}
        />
        <StackNavigator.Screen
          name={Screens.SettingsApi}
          component={ApiScreen}
        />
        <StackNavigator.Screen
          name={Screens.SettingsEngage}
          component={EngageSettingsScreen}
        />
        <StackNavigator.Screen
          name={Screens.SettingsSso}
          component={SsoSettingsScreen}
        />
        <StackNavigator.Screen
          name={Screens.SETTINGS_ORGANISATION}
          component={OrganisationScreen}
        />
        <StackNavigator.Screen
          name={Screens.SETTINGS_FIELDS}
          component={FieldSettingsScreen}
        />
        <StackNavigator.Screen
          name={Screens.SettingsGeneral}
          component={GeneralSettingsScreen}
        />
        <StackNavigator.Screen
          name={Screens.SETTINGS_QUESTIONS}
          component={AssessmentSetupLibraryScreen}
        />
        <StackNavigator.Screen
          name={Screens.SETTINGS_ASSESSMENTS}
          component={AssessmentSetupScreen}
        />
        <StackNavigator.Screen
          name={Screens.SettingsAssessmentCompliance}
          component={SettingsAssessmentCompliance}
        />
      </StackNavigator.Navigator>
    ),
    [screenSize],
  );

  return (
    <>
      {screenSize === 'large' ? (
        <View style={styles.container}>
          <View style={styles.explorerContainer}>
            <SettingsExplorerScreen />
          </View>
          <View style={styles.navigatorContainer}>{stack}</View>
        </View>
      ) : (
        stack
      )}
      <SyncIndicator showSyncIcon={false} />
    </>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'row',
  },
  explorerContainer: {
    borderRightColor: '#DDDDDD',
    borderRightWidth: 1,
    flex: 1,
  },
  navigatorContainer: {
    flex: 1,
    overflow: 'hidden',
  },
});
